import "./new-visit.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormVisit from "../form-visit/form-visit";
import { useNewVisit } from "./new-visit.hook";

export interface NewVisitProps {
  isAlone?: boolean;
}
export function NewVisit({ isAlone }: NewVisitProps) {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewVisit();

  return (
    <div id="NewVisit" className="visit">
      <HeaderContent
        title={<h3>Visit</h3>}
        className="bg-slate-200"
        backIcon={isAlone ? null : <FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 gap-2 mb-4">
            <FormVisit />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewVisit;
